import { fetch } from '@ppay/client'
import { SlackChannels } from '@ppay/definitions'

export const send = (channel: SlackChannels, message: string) =>
  fetch({
    method: 'POST',
    url: '/notifications/slack',
    data: { channel, message }
  })
